import React from "react";
import { Box, Typography } from "@mui/material";
import { QUIZ } from "@/theme/quizTokens";

/**
 * Support blocks shown near the bottom of the redesigned question screens:
 * "Did you know?" facts and Trustpilot review quotes (green-star rating row).
 */

export function DidYouKnow({ text }: { text: string }) {
  return (
    <Box sx={{ maxWidth: { xs: 340, md: 510 }, textAlign: "center" }}>
      <Typography
        sx={{
          fontFamily: QUIZ.font.body,
          fontWeight: 700,
          fontSize: { xs: 14, md: 15 },
          color: QUIZ.color.ink,
          mb: "8px",
        }}
      >
        Did you know?
      </Typography>
      <Typography
        sx={{
          fontFamily: QUIZ.font.body,
          fontSize: { xs: 13.5, md: 14.5 },
          lineHeight: 1.45,
          color: QUIZ.color.ink,
          opacity: 0.85,
        }}
      >
        {text}
      </Typography>
    </Box>
  );
}

/** Trustpilot 5-star row — green squares with white stars. */
function TrustpilotStars() {
  return (
    <Box sx={{ display: "flex", gap: "2px", justifyContent: "center", mb: "10px" }}>
      {Array.from({ length: 5 }).map((_, i) => (
        <Box
          key={i}
          sx={{
            width: { xs: 13, md: 15 },
            height: { xs: 13, md: 15 },
            bgcolor: "#00B67A",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <svg viewBox="0 0 24 24" width="80%" height="80%" fill="#fff">
            <path d="M12 2l2.9 6.26L21.5 9.27l-4.75 4.14L18.18 20 12 16.9 5.82 20l1.43-6.59L2.5 9.27l6.6-1.01L12 2z" />
          </svg>
        </Box>
      ))}
    </Box>
  );
}

export function TrustpilotQuote({
  title,
  quote,
  author,
}: {
  title: string;
  quote: string;
  author: string;
}) {
  return (
    <Box sx={{ maxWidth: { xs: 340, md: 510 }, textAlign: "center" }}>
      <TrustpilotStars />
      <Typography
        sx={{
          fontFamily: QUIZ.font.body,
          fontWeight: 700,
          fontSize: { xs: 14, md: 15 },
          color: QUIZ.color.ink,
          mb: "8px",
        }}
      >
        {title}
      </Typography>
      <Typography
        sx={{
          fontFamily: QUIZ.font.body,
          fontSize: { xs: 13.5, md: 14.5 },
          lineHeight: 1.45,
          color: QUIZ.color.ink,
          opacity: 0.85,
          mb: "10px",
        }}
      >
        {quote}
      </Typography>
      <Typography
        sx={{
          fontFamily: QUIZ.font.body,
          fontWeight: 700,
          fontSize: { xs: 13, md: 14 },
          color: QUIZ.color.ink,
        }}
      >
        {author}
      </Typography>
    </Box>
  );
}
